import { AppOtpInput, Button } from "components";
import AuthLayout from "layouts/AuthLayout";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { ApiService } from "services";
import { Router } from "utils/route";

export default function OtpForm() {
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false);
  const { route } = Router();
  console.log(otp, "dom");

  const verifyOtp = async () => {
    setLoader(true);
    try {
      const data = await ApiService.verifyOtp(otp);
      console.log(data);
      setLoader(false);
      route("/createpassword");
    } catch (err) {
      console.log(err);
      setLoader(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  useEffect(() => {
    if (otp.length === 6) {
      verifyOtp();
    }
    //eslint-disable-next-line
  }, [otp]);

  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log(otp, "eeee");
        }}
        title="Enter OTP sent to your Email"
      >
        <AppOtpInput onChange={setOtp} value={otp} />
        <Button
          onClick={() => {
            verifyOtp();
          }}
          loading={loader}
          disabled={otp.length < 6 || loader}
          placeholder="Proceed"
        />
      </AuthLayout>
    </div>
  );
}
